import styled from 'styled-components';

import { settingsItemConfig } from '../../Sidenav/item-configs';
import { FixedSidenavItem } from './Item';

export const SettingsItem = styled(props => <FixedSidenavItem navigationItem={settingsItemConfig} {...props} />)`
  margin-top: auto;
`;
